import { configureStore } from '@reduxjs/toolkit'
import system from '../system/slice'

export default configureStore({
  reducer: {
    system,
  },
})
